'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loading;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Loading() {
  var outer = (0, _jquery2.default)('<div>', { class: 'mainLoading mainLoading-grow' });

  for (var i = 1; i <= 3; i++) {
    var inner = (0, _jquery2.default)('<div>', { class: 'mainLoadingDot dot-' + i });
    outer.append(inner);
  }

  return outer.get(0);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/templates/Loading.js
// module id = 11
// module chunks = 0 1